import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAiAccess } from '../ai/useAiAccess';
import { useT } from '../i18n/i18n';
import { useAssistAccess } from './useAssistAccess';

function Option({ open, to, title, action, children }: { open: boolean; to: string; title: string; action: string; children: ReactNode }) {
  const t = useT();
  if (open) {
    return (
      <Link to={to} className="card assist-option">
        <h2>{title}</h2>
        <p>{children}</p>
        <span className="btn secondary">{action}</span>
      </Link>
    );
  }
  return (
    <div className="card assist-option is-locked">
      <h2>{title}</h2>
      <p>{children}</p>
      <span className="btn secondary" aria-disabled="true">{t('Not available yet')}</span>
    </div>
  );
}

export default function AssistHome() {
  const t = useT();
  const { access: ai } = useAiAccess();
  const assist = useAssistAccess();
  return (
    <div className="assist-home">
      <div className="card">
        <h1 style={{ marginTop: 0 }}>{t('Assist')}</h1>
        <p style={{ marginBottom: 0 }}>{t('Get help planning and setting up teaching: from EasyLearning AI straight away, or from a person who has the right training.')}</p>
      </div>
      <div className="assist-options">
        <Option open={!!ai?.visible} to="/assist/ai" title={t('EasyLearning AI')} action={t('Use EasyLearning AI')}>
          {t('Ask questions about teaching, get suggestions for what to teach next, and change the Talk Board by voice. Answers come in seconds and use credits.')}
        </Option>
        <Option open={!!assist?.visible} to="/assist/experts" title={t('Ask a consultant')} action={t('Find a consultant')}>
          {t('Choose a qualified, checked consultant to set up EasyLearning, plan a course, make programs, a weekly schedule or a milestone plan for your learner. You get an estimate first and pay only if you accept it.')}
        </Option>
        <Option open to="/assist/learn" title={t('Learn about autism')} action={t('Read the guides')}>
          {t('Plain guides on understanding autism, teaching new skills, everyday life and the support you can get. Each one is checked by a qualified professional and lists its sources.')}
        </Option>
      </div>
      {assist && (assist.visible || assist.expertStatus) && (
        <p className="field-hint">
          {t('Are you a teacher, therapist or other specialist?')} <Link to="/assist/expert">{t('Work as a consultant')}</Link>.
          {assist.admin && <> · <Link to="/assist/admin">{t('Consultants and payouts')}</Link></>}
        </p>
      )}
    </div>
  );
}
